<template>

  <div id="app"  :style="style_css_string" :class="{ 'day_mode': main_class=='day_mode','night_mode': main_class=='night_mode' }" v-if="isload">
    <v-style v-if="is_telegram_webapp==false">

    </v-style>

    <router-view v-if="is_enabled" name="header"  ref="headerComponent" :key="header_key_component+random_string"></router-view>
    <main v-if="is_enabled">
      <fade-transition origin="center" mode="out-in" :duration="250">
        <router-view :key="url_load+$route.params.toString()+random_string"/>
      </fade-transition>
    </main>
    <div v-if="is_enabled==false" class="second_section">
      <div >
        <p>Увы,но так дела не пойдут. Приложение работает только если вы разрешите боту писать вам.</p>
        <p>Мы не собираемся слать вам спам. И если вас раздражают уведомления выключите звук у нашего бота.</p>
        <p>с Уважением администрация!</p>
        <p><button @click="checkForBotNotify()" class="btn btn-second">Включить уведомления</button></p>

      </div>
    </div>
    <router-view v-if="is_enabled" :key="footer_key_component+random_string_footer" name="footer"></router-view>
    <v-style v-if="main_class=='night_mode'">
      body { background: black; }
    </v-style>
    <v-style v-if="main_class=='day_mode'">
      body { background: white; }

    </v-style>
    <v-style v-if="checkIsVK()">

      @media (max-width: 720px){
      .help_page > div{
      margin-top:20px;
      }
      .mobile_logo_block,.after_mobile_logo{
      padding-top: 60px;
      }
      .after_mobile_logo{
      padding-top: 80px;
      }
      main{
      margin-top:50px;
      }
      }
    </v-style>

  </div>
</template>

<script>
import {FadeTransition} from "vue2-transitions";
import {eventBus} from "./main.js";
import axios from "axios";
import Vue from "vue";
import Api from "./models/Api";
import "@/assets/css/custom.css";
import UserModel from "./models/UserModel";
import bridge from '@vkontakte/vk-bridge';
import {loadScript} from "vue-plugin-load-script";
// import Component from 'vue-class-component'
//
// Component.registerHooks([
//
//   'beforeRouteEnter'
// ])
export default {
  components: {
    FadeTransition
  },
  data      : function () {
    return {
      'is_enabled':true,
      "is_telegram_webapp":false,
      'header_key_component': 'default_header',
      'footer_key_component':'default_footer',
      'isload'              : false,
      'login_from_telegram' : false,
      "url_load"            : "",
      'ADDITIONAL_CSS'      : null,
      "random_string"       : "",
      "random_string_footer":"",
      "tg_start_param"      : "",
      "main_class"          : "day_mode",
      "is_header_load"      : false,
      "is_main_load"        : false,
      "is_footer_load"      : false,
      'main_day_color':'#FF9200',
      'main_night_color':'#0dda4d',
      'style_css_string':'',

    }
  },
  // beforeRouteUpdate(to, from, next) {
  //
  //
  //   //next();
  // },
  // beforeRouteEnter(to,from,next){
  //
  //   next({"path":"/"});
  // },
  watch: {
    // $route() {
    //   this.$nextTick(this.routeLoaded);
    // }

    $route(to, from) {
      // react to route changes...

      eventBus.$emit("change_disable_footer_mobile",{});
      if (from.path != "/") {
        if (!(window.Telegram && window.Telegram.WebApp && window.Telegram.WebApp.initData)) {
          location.reload();
        }

      }

      if (to !== from) {

      }
      if (this.$route.query && this.$route.query.partner) {
        localStorage.setItem("partner_id", this.$route.query.partner);
      }

      if (this.$route.query && this.$route.query.nextUrl) {
        if(this.$route.query.nextUrl.includes("?tgWebAppStartParam=")){
         var newUrl=this.$route.query.nextUrl.replace("/?tgWebAppStartParam=","");
         newUrl=newUrl.split("#")[0];
         newUrl=newUrl.replaceAll("s1s","/");
         localStorage.setItem("nextUrl",newUrl);
        }else {
          localStorage.setItem('nextUrl', this.$route.query.nextUrl);
        }

      }

      if (this.$route.query && this.$route.query.need_reload) {
        this.header_key_component = this.header_key_component + "1";
      }

      const params_hash = new Proxy(new URLSearchParams(window.location.hash), {
        get: (searchParams, prop) => searchParams.get(prop),
      });



      try {
        //  UserModel.parseGetRedirect(this);

        if (this.refs.headerComponent) {
          const el = this.refs.headerComponent;
          if (el) {
            el.changeSubLink(to.path);
          }
        }
      } catch (err) {
      }

    }
  },

  methods: {
    routeLoaded() {

    },
    checkIsVK(){
      if (localStorage.getItem("isVkIframe") != null) {
        var result_vk_iframe=localStorage.getItem("isVkIframe");
        if(result_vk_iframe=="on"){
          return true;
        }else {
          return false;
        }
      }else {
        return false;
      }


    },
    checkForBotNotify(){
      var app=this;
      try{
        if(!(window.Telegram.WebApp.initDataUnsafe.user.allows_write_to_pm==true)){
          window.Telegram.WebApp.requestWriteAccess(function(is_can){
            if(is_can==true){
              app.is_enabled=true;
            }else {
              app.is_enabled=false;
            }

          });

        }else {
          app.is_enabled=true;
        }
      }catch(err){

      }
    },
    getCurrentThemeMode(){
      var app=this;
      var main_class="day_mode";
      if(window &&    window.Telegram &&  window.Telegram.WebApp && window.Telegram.WebApp.platform && window.Telegram.WebApp.platform!="unknown" && window.Telegram.WebApp.colorScheme){
        var color_schema=window.Telegram.WebApp.colorScheme;
        if(color_schema=="dark"){
          main_class="night_mode";
        }
      }else if(localStorage.getItem("theme_mode")){
        main_class=localStorage.getItem("theme_mode");
      }
      return main_class;
    },
    //  checkingTelegramThemeNew() {
    //   var app_current=this;
    //   if(window &&  window.Telegram &&  window.Telegram.WebApp && window.Telegram.WebApp.colorScheme){
    //     var color_schema=window.Telegram.WebApp.colorScheme;
    //
    //     console.log('current check theme',{"color_schema":color_schema,"main_class":app_current.main_class});
    //     if((color_schema=="dark" && app_current.main_class=="day_mode") || (color_schema=="light" && app_current.main_class=="night_mode")){
    //       if(color_schema=="dark" ){
    //         app_current.main_class = "night_mode";
    //
    //       }else {
    //         app_current.main_class = "day_mode";
    //       }
    //
    //       app_current.set_theme(app_current.main_class);
    //
    //
    //
    //     }
    //
    //
    //   }
    //
    // },
    async checkingTelegramTheme() {
      var app_current=this;

      if(window &&  window.Telegram &&  window.Telegram.WebApp && window.Telegram.WebApp.colorScheme && UserModel.isTWA()){
        var color_schema=window.Telegram.WebApp.colorScheme;

        if((color_schema=="dark" && app_current.main_class=="day_mode") || (color_schema=="light" && app_current.main_class=="night_mode")){
          if(color_schema=="dark" ){
            app_current.main_class = "night_mode";

          }else {
            app_current.main_class = "day_mode";
          }

          app_current.set_theme(app_current.main_class);



        }


      }

},
    set_theme(theme) {
      var app        = this;
      app.main_class = theme;
      localStorage.setItem('theme_mode', app.main_class);
      eventBus.$emit("theme_is_changed", {"theme": app.main_class});
      app.random_string = Math.ceil(Math.random() * 10);
      app.changeBackgroundColor();
    },
    changeBackgroundColor() {
      var app = this;
      if (app.main_class == "night_mode") {
        document.querySelector('body').style.backgroundColor = "black";
      } else {
        document.querySelector('body').style.backgroundColor = "white";
      }
      eventBus.$emit("theme_is_changed", {"theme": app.main_class});
    },
    changeTheme() {
      var app = this;
      if (app.main_class == "day_mode") {
        app.main_class = "night_mode";
      } else {
        app.main_class = "day_mode";
      }
      localStorage.setItem('theme_mode', app.main_class);
      eventBus.$emit("theme_is_changed", {"theme": app.main_class});
      app.changeBackgroundColor();
    },

    appendCss(url) {
      let file  = document.createElement('link');
      file.rel  = 'stylesheet';
      file.href = url;
      document.head.appendChild(file)
    }

  },
  async updated(){
    var app=this;
    //app.checkingTelegramTheme();
  },
  mounted() {


    var app = this;
    if(Vue.config.MAIN_DAY_COLOR){
      app.main_day_color=Vue.config.MAIN_DAY_COLOR;
    }
    if(Vue.config.MAIN_NIGHT_COLOR){
      app.main_night_color=Vue.config.MAIN_NIGHT_COLOR;
    }
    app.style_css_string='--main-day-color2:var(--tg-theme-button-color,'+app.main_day_color+');' +
        '--main-night-theme-section-header-color:var(--tg-theme-text-color, '+app.main_night_color+');'+
        '--main-night-theme-color-primary:var(--tg-theme-button-color,'+app.main_night_color+');'+
        '--main-night-theme-color-secondary:var(--tg-theme-hint-color,'+app.main_night_color+');'+
        '--main-night-theme-color2-primary:var(--tg-theme-accent-text-color,'+app.main_night_color+');'+
        '--main-night-theme-color2-second:var(--tg-theme-subtitle-text-color,'+app.main_night_color+')';

    app.is_telegram_webapp=UserModel.checkIsWebApp();


      if (window.Telegram && window.Telegram.WebApp && window.Telegram.WebApp.initData) {
        localStorage.setItem("tg_inside_init_data", JSON.stringify(window.Telegram.WebApp.initData));

       app.checkForBotNotify();

        try{
          window.Telegram.WebApp.ready();
          window.Telegram.WebApp.SettingsButton.show();
          window.Telegram.WebApp.SettingsButton.onClick(function(){
            app.$router.push({name: "setup_link"});
          })

        }catch(err){

        }



      }
      if (window.Telegram && window.Telegram.WebApp && window.Telegram.WebApp.initData) {

        var theme_mode = "day_mode";
        if (window && window.Telegram && window.Telegram.WebApp && window.Telegram.WebApp.colorScheme == "dark") {
          theme_mode = "night_mode";
        }
        eventBus.$emit("set_name_theme", {"theme": theme_mode})
        if (window && window.Telegram && window.Telegram.WebApp.initDataUnsafe && window.Telegram.WebApp.initDataUnsafe.start_param) {
          var need_url = window.Telegram.WebApp.initDataUnsafe.start_param;
          need_url     = need_url.replaceAll("s1s", "/");
          if (app.$route.fullPath != need_url) {


            app.$router.push({path: need_url, hash: document.location.hash});
          }
        }
      }


    if (Vue.config.ADDITIONAL_CSS) {
      this.ADDITIONAL_CSS = Vue.config.ADDITIONAL_CSS;
      this.appendCss(this.ADDITIONAL_CSS);
    }

    let uri      = window.location.search.substring(1);
    const params = new Proxy(new URLSearchParams(window.location.search), {
      get: (searchParams, prop) => searchParams.get(prop),
    });

    if (params.vk_app_id) {
      bridge.send("VKWebAppInit");
      localStorage.setItem('isVkIframe', "on");



    } else {
      var canoff = true;
      if (localStorage.getItem("isVkIframe") != null) {
        var result_vk_iframe = localStorage.getItem("isVkIframe");
        if (result_vk_iframe == "on") {
          canoff = false;
        }
      }
      if (canoff == true) {
        localStorage.setItem("isVkIframe", "off");
      }

    }

    try {
      if (window.location.hash && window.location.hash.length > 0
          && !(window.location.hash && window.location.hash.length > 0 && window.location.hash.includes('tgWebAppData'))) {
        var hash_split = window.location.hash.split("link=");

        if (hash_split[1]) {
          var next_vk_url = hash_split[1];
          //localStorage.setItem('nextUrl', hash_split[1]);

          //localStorage.setItem("check_hash",1);
          this.$router.push(next_vk_url);

        }

      }
    } catch (err) {

    }

    this.login_from_telegram = false;
    if (window.Telegram) {
      this.login_from_telegram = true;
    }

    if (this.$route.query && this.$route.query.partner) {
      localStorage.setItem("partner_id", this.$route.query.partner);
    }



      this.main_class = this.getCurrentThemeMode();
      this.set_theme(this.main_class);
      //eventBus.$emit("theme_is_changed", {"theme": this.main_class});





    var app_current=this;

  // app_current.checkingTelegramTheme();




    var url = this.$route.fullPath;


    // if(url && url.includes("#tgWebAppData=")){
    //
    //
    //   var urls=url.split("#tgWebAppData=");
    //   if(urls[0]){
    //
    //     this.url_load=urls[0];
    //   }
    // }else {
    //   this.url_load=url;
    // }
    this.url_load   = url;
    var current_app = this;

    eventBus.$on("redirect_to_login_page",data=>{
      if(current_app.$route.name!="login"){
        if(current_app.$route.meta && current_app.$route.meta.need_login && current_app.$route.meta.need_login==true){
          current_app.$router.push({name: 'login',query: { nextUrl: current_app.$route.fullPath }});

        }
      }

    });

    eventBus.$on("set_name_theme", data => {
      current_app.set_theme(data.theme);
    })
    eventBus.$on("user_is_success_login",data=>{
      current_app.random_string_footer = Math.ceil(Math.random() * 10);
    })
    eventBus.$on("changeTheme", callback => {
      current_app.changeTheme();
    })
    eventBus.$on("route_is_change", data => {

      current_app.$refs.headerComponent.changeSubLink(data.to.path);
      //app.subbar_active_type=data.to.path;
    });
    eventBus.$on("refresh_fast_page", data => {

      current_app.isload        = false;
      current_app.random_string = Math.ceil(Math.random() * 10);

      current_app.isload = true;

    })
    var user = UserModel.get();
    if (user) {
      if (localStorage.getItem('nextUrl') != null) {
        var nextURL = localStorage.getItem('nextUrl');
        if (this.$route.fullPath != nextURL) {
          localStorage.removeItem('nextUrl');
          this.$router.push({path: nextURL});
        }
      }
      var paramsString_Arr = document.location.href.split('?');

      if (paramsString_Arr && paramsString_Arr[1]) {

        let paramString = paramsString_Arr[1].split("#")[0];

        let queryString        = new URLSearchParams(paramString);

        var tgWebAppStartParam = queryString.get('tgWebAppStartParam');

        this.tg_start_param = tgWebAppStartParam;

        if (current_app.$route && tgWebAppStartParam) {
          var need_url = tgWebAppStartParam;
          need_url     = need_url.replaceAll("s1s", "/");

          if (current_app.$route.path != need_url) {

            current_app.$router.push(need_url);
          }

        }
      }

    }

    if (this.$route.query && this.$route.query.partner) {
      localStorage.setItem("partner_id", this.$route.query.partner);
    }

    // alert('11');
    //  this.$router.onError(function(e){
    //
    //  })
    //  if(this.$route.hash && this.$route.hash.includes("#tgWebAppData=")){
    //    this.$route.hash="";
    //  }
    document.onreadystatechange = () => {
      if (document.readyState == "complete") {
        // if(this.$route.hash && this.$route.hash.includes("tgWebAppData=")){
        //
        //   var fullPath=this.$route.fullPath;
        //   var arrs=fullPath.split("#tgWebAppData");
        //   var normal_url=window.location.pathname;
        //
        //   var arr_router={};
        //   arr_router.path=normal_url;
        //   var query={};
        //   if(this.$route.query.rand_code){
        //     query.rand_code=this.$route.query.rand_code;
        //   }
        //
        //   if(this.$route.query.redirect_inner){
        //     query.redirect_inner=this.$route.query.redirect_inner;
        //   }
        //   arr_router.query=query;
        //
        //   this.$router.push(arr_router);
        //
        //   //document.location=arrs[0];
        //
        // }else {
        //   this.isload=true;
        // }
        this.isload = true;

        eventBus.$on('reload', (user) => {

          Api.loadUserInfo(user.api_token);
        });
      }
    }

    // alert(this.$route.hash);

    eventBus.$on('update_user_info', (isauth, isadmin) => { // here you need to use the arrow function
      app.isauth  = isauth;
      app.isadmin = isadmin;

    })
  },
};
</script>
